import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { Player } from '../../model/player';

@Component({
  selector: 'app-player-basic-info',
  templateUrl: 'player-basic-info.component.html',
  styleUrls: ['player-basic-info.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class PlayerBasicInfoComponent implements OnInit, OnChanges {

  @ViewChild('playerNameContainer', { read: ElementRef }) playerNameContainer: ElementRef;
  @ViewChild('playerNameText', { read: ElementRef }) playerNameText: ElementRef;

  @Input() player: Player;

  protected isActiveCarousel: boolean = false;

  constructor() { }

  async ngOnChanges() {
    this.updateIsActiveCarousel();
  }

  async ngOnInit() {
    this.updateIsActiveCarousel();

  }

  private async updateIsActiveCarousel(): Promise<void> {

    const checkDelay = 50;

    while (!this.playerNameContainer || !this.playerNameText) {
      await new Promise(resolve => setTimeout(resolve, checkDelay));
    }

    for (let i = 0; i < 10; i++) {
      await new Promise(resolve => setTimeout(resolve, checkDelay));
      const textSize = this.playerNameText.nativeElement.offsetWidth;
      const containerSize = this.playerNameContainer.nativeElement.offsetWidth;
      this.isActiveCarousel = textSize > containerSize;
    }
  }

}
